export const SUGGESTIONS_STORAGE_KEY = "si:column-suggestions";
